import React, { useEffect, useState } from 'react'
import Dashboardheader from './Dashboardcomponents/Dashboardheader'
import styles from "./Dashboard.module.css"
import Environmentpanel from './Dashboardcomponents/Environmentpanel'
import { Outlet, useParams } from 'react-router-dom'
import { get_all_project_Api } from '../dashboardapi';

const Dashboard = () => {
    const [token, setToken] = useState("");
    const [projects, setProjects] = useState([]);

    const { project } = useParams()

    useEffect(() => {
        let token = localStorage.getItem("token")
        setToken(token)
    }, []);

    return (
        <div className={styles.dashboard_outer}>
            <div className={styles.dashboard_head}>
                <Dashboardheader />
            </div>
            <div className={styles.environment_panel}>
                <Environmentpanel />
            </div>
            <div className={styles.project_display}>
                <Outlet />
            </div>
        </div>
    )
}

export default Dashboard